module.exports = {
  siteTitle: 'Samfunnskunnskap app', // <title>
  manifestName: 'samfunnskunnskap-app',
  manifestShortName: 'Landing', // max 12 characters
  manifestStartUrl: '/',
  manifestBackgroundColor: '#663399',
  manifestThemeColor: '#663399',
  manifestDisplay: 'standalone',
  manifestIcon: 'src/assets/img/samfunn-icon.png',
  pathPrefix: `/samfunnskunnskap-app/`, // This path is subpath of your hosting https://domain/portfolio
  // social
  socialLinks: [
    {
      icon: 'fa-facebook-f',
      name: 'Facebook',
      url: 'https://www.facebook.com/samfunnstestapp/',
    },
    {
      icon: 'fa-youtube',
      name: 'Youtube',
      url: 'https://www.youtube.com/channel/UCnnTgWwbJ09-TN1CMEOyYYg',
    },
  ],
};
